import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FundSummaryContainer, FundSummaryContent } from "./styles";
import { summaryLoading, pageSummaryError } from "../../selectors/globalSelectors";

function PageSummary(props) {
  const { fundSummaryConfig } = props;
  return (
    <FundSummaryContainer>
      {fundSummaryConfig.map((each, index) => (
        <FundSummaryContent key={index} identifier={each.key !== "fundName"}>
          {each}
        </FundSummaryContent>
      ))}
    </FundSummaryContainer>
  );
}

PageSummary.propTypes = {
  fundSummaryConfig: PropTypes.array
};

const mapStateToProps = state => ({
  summaryIsLoading: summaryLoading(state.toJS()),
  error: pageSummaryError(state.toJS())
});

export default connect(
  mapStateToProps,
  null
)(PageSummary);
